import classNames from 'classnames';

import { LayoutRoutes } from 'src/app/popsicle/router/layoutRoutes';

import styles from './styles.module.scss';

const displayName = 'Native';

export const Native = () => {
  return (
    <div className={classNames(styles.component, 'marketing', 'layout-native')}>
      <LayoutRoutes renderKey="content" displayName={displayName} location={location} />
    </div>
  );
};

Native.displayName = displayName;
